import { EDITABLE_ACCOUNT_FIELDS } from './constants';

const trimmed = (value) => (value ?? '').trim();

/**
 * What a Save would send, and what stops it.
 *
 * auth-service's admin PATCH ignores an empty string (`user_update.go`), so a
 * field can be changed but never cleared. A field the admin emptied is
 * therefore an error rather than a request that would silently do nothing,
 * while a field that was already empty and was left alone is neither sent nor
 * validated — a sparse identity can still save a phone-only edit.
 *
 * @param {import('../../../domain/Users').ILocationUserProfile} stored
 * @param {Object<string, string>} draft - The form's values, by field key
 * @returns {{
 *   changes: import('../../../domain/Users').ILocationUserChanges,
 *   errors: Object<string, string>,
 * }}
 */
export const changedFields = (stored, draft) =>
  EDITABLE_ACCOUNT_FIELDS.reduce(
    (result, { key, requiredMessage }) => {
      const next = trimmed(draft[key]);
      if (next === trimmed(stored[key])) return result;
      if (!next) return { ...result, errors: { ...result.errors, [key]: requiredMessage } };

      return { ...result, changes: { ...result.changes, [key]: next } };
    },
    { changes: {}, errors: {} },
  );

const dollars = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
  }).format(value);

/**
 * One rate-limit cell. organization-service sends `null` for no limit and `0`
 * for a limit that blocks every shift, so the two must not read alike.
 *
 * @param {number | null} [value] - Hourly cap in dollars
 * @returns {string}
 */
export const toRateLimitLabel = (value) =>
  (value === null || value === undefined ? 'No limit' : dollars(value));
